import styled from 'styled-components'
import { Link } from 'react-router-dom'
import {
  HEADER_FONT_SIZE_DESKTOP,
  HEADER_FONT_SIZE_MOBILE, NORMAL_FONT_SIZE_DESKTOP, NORMAL_FONT_SIZE_MOBILE, NORMAL_FONT_SIZE_TABLET,
  TITLE_FONT_SIZE_DESKTOP, TITLE_FONT_SIZE_MOBILE,
  TITLE_FONT_SIZE_TABLET,
} from '../../constant'

export const PromotionWrapper = styled.div`
  background-color: rgb(247 247 247);
  padding: 24px 0;
`
export const PromotionTitleWrapper = styled.div`
  text-align: center;
  margin-bottom: 32px;
`
export const PromotionTitle = styled.div`
  text-align: center;
  margin: 0 8px 12px 8px;

  span {
    background: linear-gradient(270deg, #00B74F -22.41%, #1D4289 108.33%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;

    font-size: ${HEADER_FONT_SIZE_DESKTOP};
    font-weight: 700;
    text-transform: uppercase;
  }
`
export const PromotionDesc = styled.div`
  color: #2E2E2E;
  text-align: center;
  font-size: ${TITLE_FONT_SIZE_DESKTOP};
  font-weight: 500;
  margin-bottom: 32px;
`
export const NewsBigBox = styled.a`
  display: block;
  position: relative;
  overflow: hidden;
  border-radius: 4px;
  margin-bottom: 16px;
  background-image: url(${props => props.background});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: left top;
  min-height: 448px;

  &:last-child {
    margin-bottom: 0;
  }

  @media only screen and (max-width: 1600px) {
    min-height: 450px;
  }
  @media only screen and (max-width: 1440px) {
    min-height: 330px;
  }  
  @media only screen and (max-width: 1200px) {
    min-height: 322px;
  }
  @media only screen and (max-width: 1024px) {
    min-height: 265px;
  }
  @media only screen and (max-width: 992px) {
    min-height: 218px;
  }
  @media only screen and (max-width: 768px) {
    min-height: 205px;
    margin: 0;
  }
  @media only screen and (max-width: 480px) {
    min-height: 260px;
    padding: 16px 8px;
    margin: 0;
  }
`
export const NewsBigDesc = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  background-color: #00000099;
  padding: 16px 24px;
  width: 100%;
  text-align: justify;
  
  color: #FFF;
  font-size: ${NORMAL_FONT_SIZE_DESKTOP};
  font-weight: 600;

  @media only screen and (max-width: 1440px) {
    font-size: ${NORMAL_FONT_SIZE_TABLET};
  }
  @media only screen and (max-width: 768px) {
    font-size: ${NORMAL_FONT_SIZE_TABLET};
  }
  @media only screen and (max-width: 480px) {
    font-size: ${NORMAL_FONT_SIZE_MOBILE};
  }
`
export const NewsSmallBox = styled.a`
  display: flex;
  border-radius: 4px;
  overflow: hidden;
  gap: 16px;

  &:last-child {
    margin-bottom: 0;
  }

  @media only screen and (max-width: 1600px) {
    flex-direction: row;
    justify-content: center;
    align-items: start;
    margin-bottom: 22px;
  }
  @media only screen and (max-width: 1440px) {
    margin-bottom: 27px;
  }
  @media only screen and (max-width: 992px) {
    margin-bottom: 8px;
  }
  @media only screen and (max-width: 768px) {
    flex-direction: row;
    justify-content: start;
    align-items: start;
    margin-bottom: 8px;
  }
  @media only screen and (max-width: 480px) {
    flex-direction: row;
    justify-content: start;
    align-items: start;
    margin-bottom: 8px;
  }
`
export const NewsSmallImage = styled.div`

  @media only screen and (max-width: 1600px) {
    margin-right: 0;
    &:first-child {
      padding-top: 0;
    }
  }
  @media only screen and (max-width: 1440px) {
    margin-right: 0;
    &:first-child {
      padding-top: 0;
    }
  }
  @media only screen and (max-width: 1024px) {
    margin-right: 0;
    &:first-child {
      padding-top: 0;
    }
  }
  @media only screen and (max-width: 768px) {
    margin-right: 0;
    &:first-child {
      padding-top: 0;
    }
  }
  @media only screen and (max-width: 480px) {
    margin-right: 0;
    &:first-child {
      padding-top: 0;
    }
  }

  img {
    border-radius: 4px;
    height: 214px;
    width: auto;
    margin-right: 8px;

    @media only screen and (max-width: 1440px) {
      height: 152px;
      width: auto;
    }
    @media only screen and (max-width: 1200px) {
      height: 147px;
      width: auto;
    }
    @media only screen and (max-width: 1024px) {
      height: 118px;
      width: auto;
    }
    @media only screen and (max-width: 992px) {
      height: 105px;
      width: auto;
    }
    @media only screen and (max-width: 768px) {
      height: 89px;
      width: auto;
    }
    @media only screen and (max-width: 480px) {
      height: 89px;
      width: auto;
    }
  }
`
export const NewsSmallContent = styled.div`
  @media only screen and (max-width: 992px) {
  }
  @media only screen and (max-width: 768px) {
    flex-direction: column;
    align-items: start;
  }
`
export const NewsSmallDesc = styled.div`
  color: #2E2E2E;
  font-size: ${NORMAL_FONT_SIZE_DESKTOP};
  font-weight: 400;
  text-align: justify;
  font-style: italic;

  @media only screen and (max-width: 1600px) {
    font-size: ${NORMAL_FONT_SIZE_DESKTOP};
    max-height: 100px;
  }
  @media only screen and (max-width: 1440px) {
    font-size: ${NORMAL_FONT_SIZE_DESKTOP};
    max-height: 100px;
  }
  @media only screen and (max-width: 1200px) {
    font-size: ${NORMAL_FONT_SIZE_TABLET};
    max-height: 100px;
  }
  @media only screen and (max-width: 1024px) {
    font-size: 13px;
    max-height: 100px;
  }
  @media only screen and (max-width: 992px) {
    font-size: ${NORMAL_FONT_SIZE_TABLET};
    max-height: 100px;
  }
  @media only screen and (max-width: 768px) {
    font-size: ${NORMAL_FONT_SIZE_TABLET};
  }
  @media only screen and (max-width: 480px) {
    font-size: ${NORMAL_FONT_SIZE_MOBILE};
  }
`

export const NewsButton = styled.span`
  display: inline-block;
  cursor: pointer;
  background: ${props => props.background || '#00B74F'};
  border: 1px solid ${props => props.borderColor || '#fff'};
  color: ${props => props.color || '#fff'};
  border-radius: 100px;
  padding: 8px 16px;

  @media only screen and (max-width: 1024px) {
    margin-bottom: 8px;
    font-size: 11px;
    padding: 4px 8px;
  }
  @media only screen and (max-width: 768px) {
    padding: 4px 8px;
    font-size: 10px;
    margin-bottom: 4px;
    margin-right: 8px;
    min-width: 50px;
  }
`